import React, { useEffect, useState, useRef, useCallback } from 'react';
import axios from "axios";
import { Config } from "../../config";

function CVECard({ className }) {
  const [cves, setCves] = useState([]);
  const [page, setPage] = useState(1);
  const [loading, setLoading] = useState(false);
  const [searchMode, setSearchMode] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const [noResults, setNoResults] = useState(false);

  const observer = useRef();
  const lastCVEElementRef = useCallback(node => {
    if (loading) return;
    if (observer.current) observer.current.disconnect();
    observer.current = new IntersectionObserver(entries => {
      if (entries[0].isIntersecting) {
        if (entries[0].isIntersecting) {
          cves.length > 1 && setPage(prevPage => prevPage + 1);
        }
      }
    })
    if (node && !loading && !searchMode) observer.current.observe(node);
  }, [loading, searchMode]);

  const getCVEs = async (page) => {
    setLoading(true);
    try {
        const res = await axios.get(Config.APIBaseURL + '/cves/' + page );
        if (res) {
          setCves(prevCVEs => [...prevCVEs, ...res.data]);
        } else {
            console.log('fetching cves failed');
        }
    } catch (error) {
        console.log(error);
    }
    setLoading(false);
  }

  const searchCVEs = async (term) => {
    setSearchMode(true);
    const res = await axios.get(Config.APIBaseURL + '/search_cves/' + term );
    if (res && res.data && res.data.length > 0) {
      setNoResults(false);
      setCves(res.data);
    } else {
      setNoResults(true);
      setCves([]);
    }
  }

  const handleSearch = (event) => {
    event.preventDefault();
    searchTerm.trim() !== '' && searchCVEs(searchTerm);
  }

  useEffect(() => {
    getCVEs(page); 
  }, [page]);

  return (
    <div className={className || "col-span-full xl:col-span-6 bg-white dark:bg-slate-800 shadow-lg rounded-sm border border-slate-200 dark:border-slate-700 h-[400px] overflow-auto"}>
      <header className="px-5 py-4 border-b border-slate-100 dark:border-slate-700 flex justify-between items-center space-x-16">
        <h2 className="text-sm font-semibold text-slate-200">Latest CVEs</h2>
        <form className="flex-grow" onSubmit={handleSearch}>
          <div class="relative">
            <input id="form-search" class="form-input" style={{ paddingLeft: '30px' }} type="search" value={searchTerm} onChange={e => setSearchTerm(e.target.value)} />
            <button class="absolute inset-0 right-auto group" type="submit" aria-label="Search">
              <svg class="w-4 h-4 shrink-0 fill-current text-slate-400 dark:text-slate-500 group-hover:text-slate-500 dark:group-hover:text-slate-400 ml-3 mr-2" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
                <path d="M7 14c-3.86 0-7-3.14-7-7s3.14-7 7-7 7 3.14 7 7-3.14 7-7 7zM7 2C4.243 2 2 4.243 2 7s2.243 5 5 5 5-2.243 5-5-2.243-5-5-5z"></path>
                <path d="M15.707 14.293L13.314 11.9a8.019 8.019 0 01-1.414 1.414l2.393 2.393a.997.997 0 001.414 0 .999.999 0 000-1.414z"></path>
              </svg>
            </button>
          </div>
        </form>
      </header>
      <div className="p-3">
        <div>
          {noResults && <div class="text-center text-slate-500 dark:text-slate-400">No results found</div>}
          {cves && cves.map((cve, index) => (
            <div ref={cves.length === index + 1 ? lastCVEElementRef : null} key={index} class="inline-flex flex-col w-full max-w-lg px-4 py-2 rounded-sm text-sm bg-white dark:bg-slate-800 shadow-lg border border-slate-200 dark:border-slate-700 text-slate-500 dark:text-slate-200 hover:bg-gray-100 dark:hover:bg-slate-700">
              <a href={`https://nvd.nist.gov/vuln/detail/${cve._source.cve.id}`} target="_blank" rel="noopener noreferrer" class="text-sm max-w-fit inline-block font-medium bg-purple-900 text-white hover:text-gray-300 dark:text-slate-100 rounded-full text-center px-2.5 py-1">{cve._source.cve.id}</a>
              <p class="py-2">{cve._source.cve.descriptions[0].value}</p>
              <p class="py-2"><strong>Published:</strong> {new Date(cve._source.cve.published).toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric', hour: '2-digit', minute: '2-digit', second: '2-digit' })}</p>
              {cve._source.cve.metrics.cvssMetricV31 && [cve._source.cve.metrics.cvssMetricV31[0]].map((metric, metricIndex) => (
                <div key={metricIndex}>
                  <p class={`text-sm inline-flex font-medium rounded-full text-center px-2.5 py-1 ${metric.cvssData.baseScore >= 9 ? 'bg-red-900 text-white' : metric.cvssData.baseScore >= 7 ? 'bg-red-500 text-white' : metric.cvssData.baseScore >= 4 ? 'bg-yellow-500 text-black' : 'bg-green-500 text-white'}`}>{`CVSS Score: ${metric.cvssData.baseScore}`}
                    <span class="ml-2">
                      {metric.cvssData.baseSeverity}
                    </span>
                  </p>
                </div>
              ))}
          </div>
        ))}
          {/*<header className="text-xs uppercase text-slate-400 dark:text-slate-500 bg-slate-50 dark:bg-slate-700 dark:bg-opacity-50 rounded-sm font-semibold p-2">Today</header>*/}
        </div>
      </div>
    </div>
  );
}

export default CVECard;
